/* Lens controls: shared animation, explicit exceptions for filters/newsletter. */
(() => {
  if (window.lensIconMotionInstalled) return;
  window.lensIconMotionInstalled = true;
  const NS = 'http://www.w3.org/2000/svg';
  const controls = 'button, a, summary, [role="button"], [slot="signed-out-avatar"]';
  const watched = new Set();
  const resize = new ResizeObserver(entries => entries.forEach(({target}) => draw(target)));

  // Real Lens capsule borders (exact "Borde" paths, never stretched to fit an
  // arbitrary box — only letterboxed at their own fixed ratio: 58.44:36.64
  // horizontal, 36.64:58.44 vertical). Used for icon-only controls, where the
  // shape must match the brand SVG exactly.
  const BORDER_H = 'M57.94,18.32c0-9.84-7.98-17.82-17.82-17.82h-21.8c-9.84,0-17.82,7.98-17.82,17.82,0,9.84,7.98,17.82,17.82,17.82h21.8c9.84,0,17.82-7.98,17.82-17.82Z';
  const BORDER_V = 'M18.32.5C8.48.5.5,8.48.5,18.32v21.8c0,9.84,7.98,17.82,17.82,17.82s17.82-7.98,17.82-17.82v-21.8C36.14,8.48,28.16.5,18.32.5Z';

  function draw(control) {
    const svg = control.querySelector(':scope > .lens-control-outline');
    if (!svg) return;
    const w = control.clientWidth, h = control.clientHeight;
    if (w < 2 || h < 2) return;
    if (control.classList.contains('lens-icon-control--only')) {
      // Icon-only control: the exact brand capsule ratio, letterboxed, never stretched.
      const horizontal = w >= h;
      svg.setAttribute('viewBox', horizontal ? '0 0 58.44 36.64' : '0 0 36.64 58.44');
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      svg.firstElementChild.setAttribute('d', horizontal ? BORDER_H : BORDER_V);
      return;
    }
    // Text pill (e.g. RESETEAR): a real stadium capsule that hugs the button's
    // own box exactly, so it always contains the word instead of shrinking to
    // a fixed ratio inside it.
    const r = Math.min(w, h) / 2 - .5;
    svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.firstElementChild.setAttribute('d',
      `M ${w / 2} .5 H ${w - r - .5} A ${r} ${r} 0 0 1 ${w - .5} ${r + .5} ` +
      `V ${h - r - .5} A ${r} ${r} 0 0 1 ${w - r - .5} ${h - .5} ` +
      `H ${r + .5} A ${r} ${r} 0 0 1 .5 ${h - r - .5} ` +
      `V ${r + .5} A ${r} ${r} 0 0 1 ${r + .5} .5 Z`);
  }

  function originalOutline(svg) {
    const marked = svg.querySelector('.lens-icon-outline');
    if (marked) return marked;
    const box = svg.viewBox?.baseVal;
    if (!box?.width || !box.height) return null;
    // Inline newsletter SVGs can contain an unmarked original capsule.
    for (const shape of svg.querySelectorAll('path, rect, ellipse')) {
      let b;
      try { b = shape.getBBox(); } catch { continue; }
      if (b.width < box.width * .88 || b.height < box.height * .88) continue;
      const style = getComputedStyle(shape);
      if (style.opacity === '0' || (style.stroke === 'none' && (style.fill === 'none' || style.fillOpacity === '0'))) continue;
      if (style.fill === 'none' && style.stroke !== 'none') return shape;
      // A filled compound outline is replaced by one stroke, not a second ring.
      const frame = document.createElementNS(NS, 'rect');
      frame.setAttribute('x', b.x + .5);
      frame.setAttribute('y', b.y + .5);
      frame.setAttribute('width', Math.max(1, b.width - 1));
      frame.setAttribute('height', Math.max(1, b.height - 1));
      frame.setAttribute('rx', Math.min(b.width - 1, b.height - 1) / 2);
      shape.replaceWith(frame);
      return frame;
    }
    return null;
  }

  function enhance(control) {
    if (control.closest('.removable-facet, [data-no-icon-motion]') || control.matches('.lens-cart-note')) return;
    const inCollection = control.closest('.collection__sidebar, .collection__results, .facets, .active-facets');
    const resetText = /^(resetear|restablecer|borrar todo|borrar todos|limpiar filtros|clear all|reset)$/i;
    if (inCollection && !control.matches('.collection__sidebar-reset, [type="reset"]') &&
        (control.matches('.facets-clear-all') || resetText.test(control.textContent.trim()))) {
      control.classList.add('lens-duplicate-reset');
      return;
    }
    if (control.classList.contains('lens-icon-control')) return;
    if (control.matches('.accordion__summary')) {
      if (!control.closest('.facets')) return;
      const arrow = control.querySelector('.lens-filter-arrow');
      if (!arrow) return;
      let frame = arrow.closest('.lens-filter-motion');
      if (!frame) {
        frame = document.createElement('span');
        frame.className = 'lens-filter-motion';
        arrow.before(frame);
        frame.append(arrow);
      }
      enhance(frame);
      return;
    }
    const filter = control.matches('.lens-filter-motion');
    const reset = control.matches('.collection__sidebar-reset');
    const newsletter = control.matches('.newsletter-bar__submit');
    const icon = [...control.querySelectorAll('svg, img.icon')].find(el => filter || el.closest(controls) === control);
    if (!icon && !reset) return;
    const copy = control.cloneNode(true);
    copy.querySelectorAll('svg, .sr-only, .visually-hidden, [aria-hidden="true"], cart-count').forEach(n => n.remove());
    const only = !copy.textContent.trim();
    const staged = reset || control.matches('.quantity-selector__button, .pagination__arrow') || !!control.closest('.header');
    let outline = null;
    if (icon?.tagName.toLowerCase() === 'svg') {
      outline = icon.querySelector('.lens-icon-outline');
      if (newsletter && !outline) outline = originalOutline(icon);
    }
    // An inline newsletter must reuse its SVG: never overlay another outline.
    if (newsletter && !outline) return;
    control.classList.add('lens-icon-control');
    if (only) control.classList.add('lens-icon-control--only');
    if (staged) control.classList.add('lens-icon-control--staged');
    if (outline && (only || newsletter)) {
      outline.classList.add('lens-icon-outline');
      outline.setAttribute('pathLength', '100');
      outline.setAttribute('fill', 'none');
      outline.setAttribute('stroke', 'currentColor');
      outline.parentElement.prepend(outline); // Fill stays BEHIND the icon.
      control.classList.add('lens-icon-control--native');
      return;
    }
    if (outline) outline.style.display = 'none';
    // No native capsule shipped on this control: synthesize the real Lens
    // capsule (never a circle, and never stretched for an icon-only control).
    const svg = document.createElementNS(NS, 'svg');
    svg.classList.add('lens-control-outline');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const path = document.createElementNS(NS, 'path');
    path.classList.add('lens-icon-outline');
    path.setAttribute('pathLength', '100');
    svg.append(path);
    control.prepend(svg); // Behind the icon/text, so a solid fill never hides it.
    watched.add(control);
    resize.observe(control);
    draw(control);
  }

  function scan(root) {
    if (root.nodeType !== 1 && root !== document) return;
    if (root.matches?.(controls)) enhance(root);
    root.querySelectorAll(controls).forEach(enhance);
  }
  scan(document);
  window.addEventListener('load', () => scan(document), {once: true});
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType !== 1 || node.matches('.lens-control-outline, .lens-icon-outline')) continue;
      scan(node);
      const parent = node.parentElement?.closest(controls);
      if (parent) enhance(parent);
    }
    for (const control of watched) if (!control.isConnected) {
      resize.unobserve(control);
      watched.delete(control);
    }
  }).observe(document.documentElement, {childList: true, subtree: true});

  // Click state: 0.5s of "filled" look, independent of :active (survives past
  // pointerup so a tap on mobile still shows it), never longer.
  const PRESS_MS = 500;
  document.addEventListener('pointerdown', (event) => {
    const control = event.target.closest('.lens-icon-control');
    if (!control || control.disabled || control.getAttribute('aria-disabled') === 'true') return;
    control.classList.add('lens-icon-control--pressed');
    clearTimeout(control._lensPressTimer);
    control._lensPressTimer = setTimeout(() => {
      control.classList.remove('lens-icon-control--pressed');
    }, PRESS_MS);
  });
})();